document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('[data-promo-banner-popup]');
  if (!popup) return;

  const closeButton = popup.querySelector('[data-promo-banner-close]');
  const bannerLink = popup.querySelector('.promo-banner-popup__image-link');
  const STORAGE_KEY = 'promo_banner_dismissed_until';

  const scrollPercentTrigger = parseFloat(popup.dataset.scrollPercent) || 60;
  const timeTriggerSeconds = parseFloat(popup.dataset.timeSeconds) || 20;
  const minTimeSeconds = parseFloat(popup.dataset.minTimeSeconds) || 5;
  const dismissDays = parseFloat(popup.dataset.dismissDays) || 30;

  const DISMISS_MS = dismissDays * 24 * 60 * 60 * 1000;
  const MIN_TIME_MS = minTimeSeconds * 1000;
  const TIME_TRIGGER_MS = timeTriggerSeconds * 1000;

  function isDismissed() {
    const until = localStorage.getItem(STORAGE_KEY);
    if (!until) return false;
    return Date.now() < parseInt(until, 10);
  }

  function setDismissed() {
    localStorage.setItem(STORAGE_KEY, String(Date.now() + DISMISS_MS));
  }

  function openPopup() {
    if (isDismissed() || popup.classList.contains('is-visible')) return;
    popup.classList.add('is-visible');
    document.body.classList.add('promo-banner-popup-open');
  }

  function closePopup() {
    popup.classList.remove('is-visible');
    document.body.classList.remove('promo-banner-popup-open');
    setDismissed();
  }

  if (closeButton) {
    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      closePopup();
    });
  }

  if (bannerLink) {
    bannerLink.addEventListener('click', function () {
      setDismissed();
    });
  }

  if (isDismissed()) return;

  const pageLoadTime = Date.now();
  let triggered = false;

  function maybeTrigger() {
    if (triggered) return;
    if (Date.now() - pageLoadTime < MIN_TIME_MS) return;
    triggered = true;
    openPopup();
    window.removeEventListener('scroll', handleScroll);
    clearTimeout(timeFallback);
  }

  function handleScroll() {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    const scrolledPercent = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 100;
    if (scrolledPercent >= scrollPercentTrigger) {
      maybeTrigger();
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });

  const timeFallback = window.setTimeout(maybeTrigger, TIME_TRIGGER_MS);
});